import React from 'react';
import { X, AlertTriangle, CheckCircle } from 'lucide-react';
import './ConfirmInventarioModal.css';

const ConfirmInventarioModal = ({
  onClose,
  onConfirm,
  temporada,
  semana,
  totalOrders,
  totalCajas,
  loading,
  error
}) => {
  return (
    <div className="confirm-inventario-overlay" onClick={onClose}>
      <div className="confirm-inventario-modal" onClick={(e) => e.stopPropagation()}>
        <div className="confirm-modal-header">
          <div className="warning-icon">
            <AlertTriangle size={32} />
          </div>
          <button className="btn-close" onClick={onClose} disabled={loading}>
            <X size={20} />
          </button>
        </div>

        <div className="confirm-modal-body">
          <h2>Confirmar Rebaja de Inventario</h2>
          <p className="warning-message">
            Esta acción rebajará el inventario para todos los pedidos nacionales de esta semana.
            <strong> Esta operación no se puede deshacer.</strong>
          </p>

          {error && (
            <div className="modal-error-message">
              <AlertTriangle size={20} />
              <span>{error}</span>
            </div>
          )}

          <div className="summary-box">
            <h3>Resumen de la Operación</h3>
            <div className="summary-grid">
              <div className="summary-item">
                <span className="summary-label">Temporada:</span>
                <span className="summary-value">{temporada}</span>
              </div>
              <div className="summary-item">
                <span className="summary-label">Semana:</span>
                <span className="summary-value">{semana}</span>
              </div>
              <div className="summary-item">
                <span className="summary-label">Total Pedidos:</span>
                <span className="summary-value">{totalOrders}</span>
              </div>
              <div className="summary-item">
                <span className="summary-label">Total Cajas:</span>
                <span className="summary-value highlight">{totalCajas}</span>
              </div>
            </div>
          </div>

          <div className="confirmation-checklist">
            <div className="checklist-item">
              <CheckCircle size={20} className="check-icon" />
              <span>Todos los pedidos tienen ticket de despacho</span>
            </div>
            <div className="checklist-item">
              <CheckCircle size={20} className="check-icon" />
              <span>Los datos han sido verificados</span>
            </div>
          </div>
        </div>

        <div className="confirm-modal-footer">
          <button
            className="btn-cancel"
            onClick={onClose}
            disabled={loading}
          >
            Cancelar
          </button>
          <button
            className="btn-confirm"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? 'Rebajando...' : 'Confirmar Rebaja'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmInventarioModal;
